import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-4" }
const _hoisted_2 = { class: "d-flex justify-space-between" }
const _hoisted_3 = ["value", "placeholder"]
const _hoisted_4 = { class: "d-flex justify-space-between" }
const _hoisted_5 = ["value", "placeholder"]
const _hoisted_6 = { class: "d-flex my-2 justify-space-between" }
const _hoisted_7 = ["value", "placeholder"]
const _hoisted_8 = { class: "mt-2" }
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]

import { withDefaults } from 'vue'
import { DfNode } from '@/interfaces/drawflow'

interface IProps {
  toggleDetails?: () => void
  node?: DfNode
}


export default /*#__PURE__*/_defineComponent({
  props: {
    toggleDetails: { type: Function, required: false, default: () => ({}) },
    node: { type: null, required: false, default: () => ({} as DfNode) }
  },
  setup(__props: any) {

const props = __props as { toggleDetails: () => void, node: DfNode }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('steps.subscribe.desc')), 1),
      _createElementVNode("div", {
        class: "ml-1",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (props.toggleDetails && props.toggleDetails(...args)))
      }, [
        _createElementVNode("input", {
          class: "dynamic-field",
          value: props.node.data.templateAlias,
          disabled: "",
          placeholder: _ctx.$t('steps.empty')
        }, null, 8, _hoisted_3)
      ])
    ]),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t('steps.subscribe.desc2')), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('steps.subscribe.desc3')), 1),
      _createElementVNode("div", {
        class: "ml-1",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (props.toggleDetails && props.toggleDetails(...args)))
      }, [
        _createElementVNode("input", {
          class: "dynamic-field",
          value: props.node.data.alreadySubscribedTemplateAlias,
          disabled: "",
          placeholder: _ctx.$t('steps.empty')
        }, null, 8, _hoisted_5)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('steps.subscribe.desc4')), 1),
      _createElementVNode("div", {
        class: "ml-1",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (props.toggleDetails && props.toggleDetails(...args)))
      }, [
        _createElementVNode("input", {
          class: "dynamic-field",
          value: props.node.data.renderEngine,
          disabled: "",
          placeholder: _ctx.$t('steps.empty')
        }, null, 8, _hoisted_7)
      ])
    ]),
    _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('steps.subscribe.enrichment.title')) + ":", 1),
    (props.node.data.enrichment.length <= 0)
      ? (_openBlock(), _createElementBlock("input", {
          key: 0,
          value: _ctx.$t('steps.subscribe.enrichment.empty'),
          disabled: ""
        }, null, 8, _hoisted_9))
      : _createCommentVNode("", true),
    (props.node.data.enrichment.length >= 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "ml-1",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (props.toggleDetails && props.toggleDetails(...args)))
        }, [
          _createElementVNode("input", {
            class: "dynamic-field",
            value: `${props.node.data.enrichment.length} ${_ctx.$t(
          'steps.subscribe.enrichment.content',
          props.node.data.enrichment.length
        )}`,
            disabled: ""
          }, null, 8, _hoisted_10)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})